import request from '@/utils/request'
import { v2Host } from '@/config/host'

export function getDcoDetail(params) {
  return request({
    url: `${v2Host}/common/dco/detail`,
    method: 'get',
    params
  })
}
